declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_spread_plain1_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_spread_plain1 extends $bog_fragile_demo_spread_base1 {
		Extra( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=plain1.view.tree.d.ts.map